import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Hook to invalidate the webhook signing secrets query.
 * Use this after creating or rotating a webhook signing secret.
 */
export const useInvalidateWebhookSigningSecrets = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: ["useWebhookSigningSecretsQuery"]
    });
  }, [queryClient]);
};
